import { useMutation } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { useProjectSnapshot } from '../../hooks/use-project-snapshot';

type Props = {
  onError: (error: Error) => void;
  onMutate: () => void;
};

const useAddLicenseQuery = (props: Props) => {
  const { project } = useProjectSnapshot();
  return useMutation({
    mutationFn: async () => {
      return SkyMapAxiosServiceFactory.instance.createCompanyServiceV0().createDesignDemoLicense({
        path: {
          companyId: project!.companyId!,
        },
      });
    },
    retry: false,
    networkMode: 'always',
    onError(error) {
      props.onError(error);
    },
    onMutate() {
      props.onMutate();
    },
  });
};

export { useAddLicenseQuery };
